module.exports = __webpack_public_path__ + "static/media/heavy_pound53.5a155226.jpg";